import Block from '../../common.blocks/block'

export default class AdviceOptions extends Block {
	static title = 'advice-options'

	constructor($el) {
		super($el)

		this.toggle = this.$el.findElement('toggle')
		this.list = this.$el.findElement('list')

		this.toggle.on('click', () => {
			const open = this.toggle.attr('aria-expanded') !== 'true'

			this.toggle.attr('aria-expanded', open)
			this.list.prop('hidden', !open)
		})
	}
}
